import React from 'react';
import AddEditCouponForm from 'ui-component/coupons/AddEditCouponForm';


function AddCoupon() {
  return (
    <div>
      <AddEditCouponForm title="Add Coupon" />
    </div>
  );
}

export default AddCoupon;
